import './password.scss';
import React from 'react';
import { Translate, translate, getUrlParameter } from 'react-jhipster';
import { connect } from 'react-redux';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { Row, Col, Button, Alert } from 'reactstrap';
import { Redirect, RouteComponentProps, Link } from 'react-router-dom';
import { IRootState } from 'app/shared/reducers';
import moment from 'moment';

export interface IUserInfoProps extends StateProps, DispatchProps {}

export interface IUserInfoState {}

export class UserInfo extends React.Component<IUserInfoProps, IUserInfoState> {
  state: IUserInfoState = {};

  convertDateToString = strDate => {
    let date = moment(strDate, 'YYYYMMDD');
    return moment(date).format('DD/MM/YYYY');
  };

  render() {
    return (
      <div>
        <Row className="justify-content-center">
          <Col>
            <h1 className="text-center font-weight-bold" id="register-title">
              Thông tin tài khoản
            </h1>
            <Row style={{ alignItems: 'center' }}>
              <Col style={{ flex: 1 }}>
                <dt>Họ và tên: </dt>
              </Col>
              <Col style={{ flex: 2 }}>
                <label>{this.props.userInfo ? this.props.userInfo.cn : ''}</label>
              </Col>
            </Row>

            <Row style={{ alignItems: 'center' }}>
              <Col style={{ flex: 1 }}>
                <dt>Số CMT/CCCD: </dt>
              </Col>
              <Col style={{ flex: 2 }}>
                <label>
                  {this.props.userInfo ? (this.props.userInfo.identity ? this.props.userInfo.identity : this.props.userInfo.citizenId) : ''}
                </label>
              </Col>
            </Row>

            <Row style={{ alignItems: 'center' }}>
              <Col style={{ flex: 1 }}>
                <dt>Số điện thoại: </dt>
              </Col>
              <Col style={{ flex: 2 }}>
                <label>{this.props.userInfo ? this.props.userInfo.mobile : ''}</label>
              </Col>
            </Row>

            <Row style={{ alignItems: 'center' }}>
              <Col style={{ flex: 1 }}>
                <dt>Ngày sinh: </dt>
              </Col>
              <Col style={{ flex: 2 }}>
                <label>{this.props.userInfo ? this.convertDateToString(this.props.userInfo.dateOfBirth) : ''}</label>
              </Col>
            </Row>

            {/* <Row style={{ alignItems: 'center' }}>
              <Col style={{ flex: 1 }}>
                <dt>Địa chỉ: </dt>
              </Col>
              <Col style={{ flex: 2 }}>
                <label>{this.props.userInfo ? this.props.userInfo.cn : ''}</label>
              </Col>
            </Row> */}
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  userInfo: storeState.passwordSet.userInfo
});

const mapDispatchToProps = {};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserInfo);
